import React, { useState } from 'react'
import { useIntl } from 'react-intl'
import { Grid, Box } from '@mui/material'
import { Alert } from '@mui/material'

import { useCombos } from '../../../combos'
import { useSignupFormContext } from '../../contexts'
import { TextInput, SelectInput } from '../../../../ui'
import { WizardView } from '../wizard'
import { COMPANY_FORM_CONFIG } from './constants'
import { isValidCIF, isValidNIF, isValidNIE } from '../../../../core/utils/idDocValidation'
import { GuildCompanyForm } from './guild-company-form'
import { MarketerCompanyForm } from './marketer-company-form'
import { InstallerCompanyForm } from './installer-company-form'
import { validateEmail } from '../../../../core/utils'
import { PrescriptorCompanyForm } from './prescriptor-company-form'

export const CompanyFormComponent = () => {
  const intl = useIntl()
  const combos = useCombos([])
  const { formState, onChange, onSubmit, isLoading } = useSignupFormContext()
  const { installerWorks } = useSignupFormContext()
  const inputProps = { formState, onChange, combos, intl }

  const [errorMssg, setErrorMssg] = useState('')

  const handleNext = ({ step, setStep }) => {
    if (!installerWorks.catchment && !installerWorks.ip) {
      setErrorMssg('Selecciona, al menos, una actividad')
    } else if (
      formState['tipo_actividad'] === '01' &&
      installerWorks.catchment &&
      !formState['registro_industrial']
    ) {
      setErrorMssg('Es obligatorio añadir un registro industrial')
    } else if (
      formState['tipo_actividad'] !== '03' &&
      installerWorks.ip &&
      formState['iban'] &&
      !formState['certificado_iban']
    ) {
      setErrorMssg('Si has informado un IBAN, debes añadir un Certificado IBAN')
    } else if (
      formState['tipo_actividad'] !== '03' &&
      installerWorks.ip &&
      !formState['iban'] &&
      formState['certificado_iban']
    ) {
      setErrorMssg('Si has añadido un Certificado IBAN, debes informar el IBAN')
    } else if (
      !isValidNIF(formState['cif']?.trim()) &&
      !isValidCIF(formState['cif']?.trim()) &&
      !isValidNIE(formState['cif']?.trim())
    ) {
      setErrorMssg('Por favor, escribe un NIF/NIE/CIF válido')
    } else if (
      !formState['cod_sap'] &&
      // ((formState['tipo_actividad'] === '01' && installerWorks.catchment) ||
      formState['tipo_actividad'] === '02' //)
    ) {
      setErrorMssg(
        'El registro de empresas sólo se permite a aquellos identificados por el sistema de Negdia'
      )
    } else if (!validateEmail(formState['email'])) {
      setErrorMssg('El email suministrado no tiene el formato correcto')
    } else {
      if (
        formState['tipo_actividad'] === '01' &&
        ((installerWorks.catchment && formState.publica === '01') || installerWorks.ip)
      )
        setStep(step + 1)
      else onSubmit()
    }
  }

  return (
    <WizardView title="Datos de la empresa" onNext={handleNext} isLoading={isLoading}>
      <Grid container spacing={3}>
        <Grid size={{xs: 12, sm: 6}}>
          <TextInput {...{ ...COMPANY_FORM_CONFIG(inputProps).NOMBRE }} />
        </Grid>
        <Grid size={{xs: 12, sm: 6}}>
          <SelectInput {...{ ...COMPANY_FORM_CONFIG(inputProps).ACTIVIDAD }} />
        </Grid>
        {formState['tipo_actividad'] === '02' ? <GuildCompanyForm /> : null}
        {formState['tipo_actividad'] === '03' ? <MarketerCompanyForm /> : null}
        {formState['tipo_actividad'] === '04' ? <PrescriptorCompanyForm /> : null}
        {formState['tipo_actividad'] === '01' ? <InstallerCompanyForm /> : null}
      </Grid>
      {errorMssg && (
        <Box mt={2} mb={1}>
          <Alert severity="error">{errorMssg}</Alert>
        </Box>
      )}
    </WizardView>
  )
}
